import { Button, Grid, Typography } from "@sidelinesports/fan-design-system";
import { LightbulbIcon } from "@sidelinesports/icons";
import type { ComponentProps } from "react";
import { Dialog } from "../../../../components";

export const MissingPointsDialog = ({
  pointsMissed,
  onFinishClose,
  ...dialogRootProps
}: {
  pointsMissed: number;
} & Omit<ComponentProps<typeof Dialog.Root>, "children"> &
  Pick<ComponentProps<typeof Dialog.Content>, "onFinishClose">) => {
  return (
    <Dialog.Root {...dialogRootProps}>
      <Dialog.Content
        size="md"
        gap="lg"
        py={24}
        onFinishClose={onFinishClose}
        name="MissingPointsDialog"
      >
        <Dialog.Illustration>
          <LightbulbIcon style={{ opacity: 0.24 }} />
        </Dialog.Illustration>
        <Dialog.Header closeButton={false}>
          Just a heads up&hellip;
        </Dialog.Header>
        <Dialog.Body>
          <Grid gap={16}>
            <Typography size="md">
              Thanks for playing! You picked your players after the beginning of
              the game, which means any scoring event that happened before you
              picked will not apply to your score.
            </Typography>
            <Typography size="md">
              You missed out on {pointsMissed} points this game, but you’ll earn
              points from here on out!
            </Typography>
          </Grid>
        </Dialog.Body>
        <Dialog.Footer>
          <Dialog.Close
            as={Button}
            variant="outline"
            size="sm"
            style={{ flexGrow: 1 }}
          >
            Close
          </Dialog.Close>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog.Root>
  );
};
